import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Space, Button, Popover, Tag, List } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { AdminRoleListRequest, AdminRoleDeleteRequest } from '../../services/api/interfaces/ApiRequest'

type AdminRoleListProps = BaseListComponentProps & {
  roles: any,
  loading: boolean,

  history: any,

  loadAdminRoles: (args: AdminRoleListRequest) => void
  deleteAdminRole: (args: AdminRoleDeleteRequest) => void
}

export default class AdminRoleList extends ListComponent<AdminRoleListProps> {

  static defaultProps = {
    loading: false
  }

  tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.description - b.description
    },
    {
      title: 'Permissions',
      dataIndex: 'permissions',
      key: 'permissions',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.permissions?.length - b.permissions?.length,
      render: (text: string, record: any) => {
        const popoverContent = (
          <div style={{height: 200, overflow: 'auto'}}>
            <List
              dataSource={record.permissions?.map(p => p.child) || []}
              renderItem={(item: any) => <List.Item>{item}</List.Item>}
              bordered
            />
          </div>
        )

        return (
          <Popover content={popoverContent} title="Child Roles" trigger="hover" placement="bottom">
            <Tag color="geekblue">{record.permissions?.length || 0}</Tag>
          </Popover>
        )
      }
    },
    {
      title: 'Actions',
      key: 'action',
      align: 'right',
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link to={`role/${record.name}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      )
    }
  ] as any

  componentDidMount() {
    this.props.loadAdminRoles({
      role: 1
    })
  }

  render() {
    const { loading, roles } = this.props

    return (
      <Table
        loading={loading}
        rowKey='name'
        columns={this.tableColumns}
        pagination={false}
        dataSource={roles}
      />
    )
  }
}
